import { buildProperty, buildCollection } from "@firecms/core";
import enumLocales from "./locales.enum";
import uniqid from "uniqid";

interface ICourse {
  custom_id: string;
  category: string;
  price: number;
  active: boolean;
  image: string;
  images: Array<string>;
  bar: string;
  color: string;
  video: string;
  pluralo_id: string;
  priority: number;
}

const CategoryLocaleSchema =  buildCollection({
  id: "category_locales",
  name: "Locale",
  path: "locales",
  customId: enumLocales,
  properties: {
    name: buildProperty({
      name: "Título",
      dataType: "string",
      columnWidth: 400,
      validation: { required: true },
    }),
}
})

const CategorySchema = buildCollection({
  id: "categories",
  name: "Categorias",
  path: "categories",
  subcollections: [CategoryLocaleSchema],
  properties: {
    custom_id: {
      name: "custom_id",
      validation: { required: true },
      dataType: "string",
    },
    priority: buildProperty({
      name: "Prioridade",
      dataType: "number",
      defaultValue: 0,
    }),
    active: {
      name: "Active",
      dataType: "boolean",
      defaultValue: true,
    },
    image: {
      name: "Image",
      dataType: "string",
      storage: {
        fileName: () => uniqid(),
        acceptedFiles: ["image/*"],
        storagePath: "images/categories",
        metadata: {
          cacheControl: "max-age=1000000",
        },
      },
    },
  },
});

export default CategorySchema;